import { debounce } from 'lodash';
import { RefObject, useEffect, useState } from 'react';

export default function useComponentInViewport(
  ref: RefObject<HTMLElement>,
  percentageInViewPort: number = 0.5,
) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkIfInView = debounce(() => {
      if (!ref.current) {
        return false;
      }

      const { bottom, top } = ref.current.getBoundingClientRect();

      const offset = percentageInViewPort * window.innerHeight;
      const bottomInView = bottom > 0 && bottom < window.innerHeight - offset;
      const topInView = top > 0 && top < window.innerHeight - offset;

      setIsVisible(bottomInView || topInView);
    });

    window.addEventListener('scroll', checkIfInView);
    return () => window.removeEventListener('scroll', checkIfInView);
  }, [ref, percentageInViewPort]);

  return isVisible;
}
